export const createRequestParams = (from?: string, to?: string, page?: number, group_id?: number | null): { [key: string]: string | undefined } => {
    const params: { [key: string]: string | undefined } = {};

    if (from) {
        params.from = from;
    }
    if (to) {
        params.to = to;
    }
    if (page !== undefined) {
        params.page = page.toString();
    }
    if (group_id !== null && group_id !== undefined) {
        params.group_id = group_id.toString();
    }

    return params;
};
